import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';
import DashboardCards from '../components/widget/DashboardCards';

import * as Constants from './../store/index';
import Filter from '../components/widget/Filter';
import Card from '../components/widget/Card';
import Button from '../components/html/Button';
import ChartRequest from '../components/widget/ChartRequest';

import axios from "axios";
import { useStatistics } from '../hooks/useStatistics';
import ConfigChat from './ConfigChat';
import Training from './Training';

function Chatbot(props) {

  
  const [isChat, setIsChat] = useState(false);
  const [loading, setLoading] = useState(false);

  const setChat = (store) =>{
    const {moduleConfig} = store;
    let isSet = false;
    if(moduleConfig){
      for (let i = 0; i < moduleConfig.length; i++) {
        if (moduleConfig[i].name == "CHATBOT") {
          setIsChat(moduleConfig[i].active);
          isSet = true;
        }
      }
    }
    if(!isSet){
      setIsChat(false);
    }
  }
  const [secondMessage, setSecondMessage] = useState(20);
  const [accountReturnPhone, setAccountReturnPhone] = useState("");
  
  let startDate = new Date();
  let endDate = new Date();
  startDate.setDate(endDate.getDate() - 60);
  
  const [filter, setFilter] = useState({
    fromNotifyDate: startDate.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'}) + "T00:00:01",
    toNotifyDate: endDate.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'})+ "T23:59:59"
  });
  const [url, setUrl] = useState("&fromDate=" +filter.fromNotifyDate + "&toDate="+filter.toNotifyDate);
  const [urlSpecial, setUrlSpecial] = useState("&fromDate=" +filter.fromNotifyDate + "&toDate="+filter.toNotifyDate);
 

  const updateFilter = (fil) => {
    setFilter(fil);
    setUrl("&fromNotifyDate=" +fil.fromNotifyDate + "&toNotifyDate="+fil.toNotifyDate+"&interval="+fil.interval);
    setUrlSpecial("&fromDate=" +fil.fromNotifyDate + "&toDate="+fil.toNotifyDate+"&interval="+fil.interval);
  }

  useEffect(() => {
    const store = Util.getAdminShop();
    setChat(store);
    if(store.plan.planType === "PLUS"){
      getAccount();
    }
  }, []);

  const getAccount = () =>{
    setLoading(true);
    let shop =  Util.getAdminShop();
    let newWA = {};
    if(shop && shop.marketingCredential){
      newWA.marketingCredential = shop.marketingCredential;
    }
    const url = window.url_server_2+"facebook/subaccount/?shop="+Util.getShopDomain();
    newWA["accessTokenStore"] = Constants.getAccessTokenStore();
    axios.post(url, newWA, {}).then(response => response.data,error => {
        return error;
      }).then((data) => {
        if (data && data.code === "200"){
          console.log(data);
          let account = JSON.parse(data.data);
          if(account.phone && account.phone !== "" ){
            setAccountReturnPhone(account.phone);
          }
        }else{
          alert("Ocurrio un error al obtener la cuenta, comuniquese con Revie!");
        }
        setLoading(false);
    });
  }


  const handleOkShoperror = (data) => {
      console.log(data);
  }


  const setDataUrl = (data) => {
    alert("Acción realizada con éxito!");
  }


  const [total, setTotal] = useState(0);
  const [timeSaved, setTimeSaved] = useState(0);

  const [totalPrice, setTotalPrice] = useState(0);
  const [count, setCount] = useState(0);

  const dataOk = (data) => {
    //setData(data);
    console.log("data",data);
    let total = 0;
    if(data && data.length > 0){
        data.map((item, key) =>{
          total += item.count; 
        });
        setTotal(total);
        //1 Mensaje = 3.75 minutos
        setTimeSaved(((total*3.5)/60).toFixed(2));
    }else{
        setTotal(0);
        setTimeSaved(0);
    }
  }

  const dataOk2 = (data) => {
    //setData(data);
    console.log("data",data);
    let total = 0;
    if(data && data.mediumCount && data.mediumCount.length > 0){
        setTotalPrice(data.totalPrice);
        setCount(data.mediumCount[0].count);
    }else{
        setCount(0);
        setTotalPrice(0);
    }
  }

  const tabs = ["Dashboard", "Entrenamiento", "Probar a Lia"];
  const [tabSelect, setTabSelect] = useState(0);

  const {isLoad} = useStatistics({ urlInicial: "intervalstatistics?type=CHATBOT" + url, callback: dataOk, server: "inboxs/messages/"})
  const {isLoad2} = useStatistics({ urlInicial: "utmstatistics?utmSource=revie&utmMedium=ia" + url, callback: dataOk2, server: "orders/"})
  const USDollar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
  });
  return (
    <div className='home' style={{paddingTop: "1rem"}}>
          <div className='title-filter'>
              <div className='tabs-filter'>
                {tabs && tabs.map((tab, key) => (<div key={key} className={tabSelect === key ? "active" : ""} onClick={() => setTabSelect(key)}>{tab}</div>))}
              </div>
              
            </div>
          {tabSelect === 0 ? (  
          <>
            <Filter isIntervalShow={false} setFilter={updateFilter} filter={filter} fromText="fromNotifyDate"  toText="toNotifyDate"/>
            <div className='content-flex space-between-start mobile-scroll flex-direction-column-mobile'>
              <DashboardCards title={Util.getMessage("analicts_campaign_2")} count={total} textTotal={Util.getMessage("analicts_campaign_2")} />
              <DashboardCards title={"TIEMPO AHORRADO"}  count={timeSaved} second={secondMessage} textTotal={"Horas"} />
              <DashboardCards title={Util.getMessage("analicts_campaign_3")} extra={(count) + " "+Util.getMessage("analicts_campaign_4")} count={USDollar.format(totalPrice)} textTotal={Util.getMessage("analicts_campaign_3")} />
            </div>
            <div className='analytics chatIA'>
              <ChartRequest title={"Mensajes respondidos por Lia"} typeValue="int" name={"WhatsApp"} typeLabel="date" delay={10} url={"inboxs/messages/intervalstatistics?type=CHATBOT" + url}/>
              <ChartRequest title={"Mensajes"} type="pie" listColors={{"CHAT":"#49A0FD","CHATBOT":"rgb(244, 165, 0)","MARKETING":"rgb(19, 153, 71)","REVIEW":"rgb(253, 87, 84)","NOTIFICATION":"#EF6537"}} pre_label="message_" typeLabel="traductor" name={"Reviews"} delay={150} url={"inboxs/messages/typestatistics?s=a" + urlSpecial} />
            </div>
            
          </>
          ) : tabSelect === 1 ? (
            <ConfigChat chatbotActive={isChat}/>
          ) : (
            <Training chatbotActive={isChat}/>
          )}
        

        
      <div>

      </div>
    </div>
  );
}

export default Chatbot;